import { render } from "./ExtractEntryDetailed.vue?vue&type=template&id=4b3ae9fc&scoped=true"
import script from "./ExtractEntryDetailed.vue?vue&type=script&lang=js"
export * from "./ExtractEntryDetailed.vue?vue&type=script&lang=js"

import "./ExtractEntryDetailed.vue?vue&type=style&index=0&id=4b3ae9fc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3ae9fc"]])

export default __exports__